package com.milta.core.localization.translations.nl

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Laden…",
    errorNoConnection = "Kan de server niet bereiken — controleer je verbinding.",
    errorGeneric = "Er is iets misgegaan. Probeer het later opnieuw.",
    emptyStateMessage = "Nog geen gegevens.",
    kpiTotalDocumentsLabel = "Geanalyseerde documenten",
    kpiCompletedDocumentsLabel = "Volledige documenten",
    kpiCompletedDocumentsSubtitle = "gesimuleerd voor de 4 strategieën",
    kpiTotalRealCostLabel = "Totale werkelijke kosten",
    kpiTotalInputTokensLabel = "Invoertokens",
    kpiTotalOutputTokensLabel = "Uitvoertokens",
    breakdownByFileKindLabel = "Verdeling",
    fileKindImageLabel = "Afbeeldingen",
    fileKindPdfLabel = "PDF's",
    fileKindXlsxLabel = "Spreadsheets",
    flowTitle = "De volledige flow, stap voor stap",
    flowYesLabel = "Ja",
    flowNoLabel = "Nee",
    flowStep1Title = "Document verzonden",
    flowStep1Subtitle = "Foto, PDF of bestand ontvangen via de app",
    flowStep2Title = "Unieke vingerafdruk berekend",
    flowStep2Subtitle = "Er wordt een unieke identificatie berekend voor dit document",
    flowStep2Note = "Indien al gezien: lokale analyse wordt niet opnieuw gedaan (de echte AI-kost wordt nog steeds normaal geteld, want het is een echte upload).",
    flowStep3Title = "Bestandstype gedetecteerd",
    flowStep3Subtitle = "De rest van de analyse verschilt per type",
    flowImageBranchTitle = "📷 Als het een foto is",
    flowImageStep1Title = "Kwaliteitscontrole",
    flowImageStep1Subtitle = "Scherpte, helderheid, resolutie, document goed gekaderd",
    flowImageStep2Title = "Als de kwaliteit onvoldoende wordt geacht",
    flowImageStep2Subtitle = "De reden wordt gelogd, maar lokale lezing wordt daarna toch geprobeerd",
    flowImageStep3Title = "Scheefstandcorrectie",
    flowImageStep3Subtitle = "De afbeelding wordt rechtgezet als een betrouwbare kanteling wordt gedetecteerd",
    flowImageStep4Title = "Lokale lezing (gratis)",
    flowImageStep4Subtitle = "Tekstlezing zonder AI — Frans, Nederlands, Engels",
    flowImageStep5Title = "Betrouwbaarheidsscore",
    flowImageStep5Subtitle = "Score van 0 tot 100 over de kwaliteit van deze lokale lezing",
    flowPdfBranchTitle = "📄 Als het een PDF is",
    flowPdfStep1Title = "Native tekst gedetecteerd?",
    flowPdfStep1Subtitle = "Controleert of de PDF al bruikbare digitale tekst bevat",
    flowPdfNote = "Indien gescand zonder native tekst: elke pagina (max. 20) wordt omgezet naar een afbeelding en lokaal herlezen, net als een foto.",
    flowXlsxBranchTitle = "📊 Als het een spreadsheet is",
    flowXlsxStep1Title = "Kolommen geïdentificeerd",
    flowXlsxStep1Subtitle = "Automatische of AI-ondersteunde herkenning van kolommen (naam, adres, telefoon…)",
    flowXlsxNote = "Bestandsstructuur (rijen, kolommen, koptekst) lokaal geanalyseerd.",
    flowClaudeTitle = "AI-aanroep (Claude)",
    flowClaudeSubtitle = "Vandaag wordt altijd een echte aanroep gedaan, ongeacht het bovenstaande pad — werkelijke kosten in rekening gebracht",
    flowSimulationTitle = "🔬 Simulatie achteraf (niet in productie)",
    flowSimulationNote = "Zodra de bovenstaande gegevens zijn verzameld, worden 4 alternatieve strategieën opnieuw toegepast op dezelfde documenten om te schatten wat ze zouden hebben gekost in plaats van de systematische AI-aanroep — dat is precies wat de onderstaande tabel vergelijkt. Geen van deze 4 strategieën wordt vandaag echt gebruikt in productie.",
    flowPersistTitle = "Opgeslagen",
    flowPersistSubtitle = "Het werkelijke resultaat en de 4 simulaties worden bewaard",
    flowDashboardTitle = "Dashboard",
    flowDashboardSubtitle = "Dit scherm verzamelt de resultaten per strategie",
    tableTitle = "Vergelijking van mogelijke strategieën",
    columnMode = "Strategie",
    columnDocuments = "Documenten",
    columnClaudeCalls = "AI-aanroepen",
    columnProjectedCost = "Geraamde kosten",
    columnRealCost = "Werkelijke kosten",
    columnSavings = "Geraamde besparing",
    modeBaseline = "Huidige strategie",
    modeBaselineDescription = "De AI wordt systematisch aangeroepen voor elk document — dit is wat vandaag echt in productie wordt gebruikt.",
    modeMinimal = "Lichte voorbewerking",
    modeMinimalDescription = "Kleine optimalisaties voor het versturen naar de AI, zonder de beslissing te wijzigen: de AI wordt altijd aangeroepen, zelfde kosten als de huidige strategie.",
    modeTesseractGate = "Lokale lezing met AI-terugval",
    modeTesseractGateDescription = "Een gratis lokale lezing beoordeelt eerst de kwaliteit van het document; de AI wordt alleen aangeroepen als deze lezing onvoldoende wordt geacht.",
    modeTesseractOnly = "Alleen lokale lezing",
    modeTesseractOnlyDescription = "Geen enkele AI-aanroep — alleen een gratis lokale lezing, mogelijk minder betrouwbaar bij documenten van slechte kwaliteit.",
)
